import type {IRootState} from "../../store/store";
import {selectUserProfile} from "../../user/api/get_user_profile";
import {getRegistrationFlowUserState} from "./get_registration_flow_user_state";

export const selectRegistrationFlowUserState = (state: IRootState) => getRegistrationFlowUserState(selectUserProfile(state).data);
import type {IRootState} from "../../store/store";
import {selectUserProfile} from "../../user/api/get_user_profile";
import {getRegistrationFlowUserState} from "./get_registration_flow_user_state";

export const selectRegistrationFlowUserState = (state: IRootState) => getRegistrationFlowUserState(selectUserProfile(state).data);
